import { adminAPI } from '../services/api';
import { buildRegistrationPaymentHoverLines } from './registrationStatusHover.js';
import { openAdminReceiptPrint } from './openAdminReceiptPrint.js';
import { getParticipantPaymentState } from './participantPaymentShare.js';
import { isNonPayingRegistration } from './registrationStaffStatus.js';

export function canViewRegistrationReceipt(booking, traveler, travelerIndex) {
  if (isNonPayingRegistration(booking)) return false;
  const { paid, pending } = getParticipantPaymentState(booking, traveler, travelerIndex);
  return paid > 0 && pending <= 0;
}

/** Fresh booking detail includes group participants on online receipts for printing. */
export async function resolveBookingForReceiptPrint(booking) {
  if (!booking?.id) return booking;
  try {
    const res = await adminAPI.getBooking(booking.id);
    return res?.data?.data || booking;
  } catch {
    return booking;
  }
}

/** Fetch enriched booking + receipt before print (group participants, snapshot). */
export async function openAdminReceiptPrintEnriched(receipt) {
  const bookingId = receipt?.bookingId || receipt?.booking?.id;
  if (!bookingId) {
    openAdminReceiptPrint(receipt, receipt?.booking);
    return;
  }
  const fresh = await resolveBookingForReceiptPrint({ id: bookingId, ...receipt?.booking });
  const rid = receipt?.id;
  let receiptToPrint = receipt;
  if (Array.isArray(fresh?.receipts) && rid != null) {
    const found = fresh.receipts.find((r) => String(r.id) === String(rid));
    if (found) receiptToPrint = { ...found, booking: fresh };
    else receiptToPrint = { ...receipt, booking: fresh };
  } else {
    receiptToPrint = { ...receipt, booking: fresh };
  }

  // Prefer live group participant list from booking GET when receipt snapshot is incomplete.
  const liveGroup = Array.isArray(fresh?.groupParticipants) ? fresh.groupParticipants : [];
  const receiptGroup = Array.isArray(receiptToPrint?.groupParticipants)
    ? receiptToPrint.groupParticipants
    : [];
  if (liveGroup.length > receiptGroup.length) {
    receiptToPrint = {
      ...receiptToPrint,
      groupParticipants: liveGroup,
      booking: fresh
    };
  }

  openAdminReceiptPrint(receiptToPrint, fresh);
}

/** Open printable tax receipt for the latest payment on this booking. */
export async function openRegistrationReceipt(booking) {
  const resolved = await resolveBookingForReceiptPrint(booking);
  const lines = buildRegistrationPaymentHoverLines(resolved);
  for (const line of lines) {
    const receipt = line.printReceipt;
    if (!receipt) continue;
    await openAdminReceiptPrintEnriched({ ...receipt, booking: resolved });
    return { ok: true };
  }
  return { ok: false, reason: 'NO_RECEIPT' };
}
